import React, { useState } from "react";
import { PayPalButton } from "react-paypal-button-v2";

export default function App() {
  const [state, setState] = useState(0);
  return (
    <div>
      <PayPalButton
        options={{
          clientId: "AWHnsE8SwF6DYhujPIjqFhUKw4h9S9Ew2e1V5Vwn85CuWHwafktuB4q3eiwrZtIfQ8EwOn4M36W_qeHu",
          currency: "USD",
        }}
        onSuccess={(details, data) => {
          alert("Transaction completed by " + details.payer.name.given_name);

          console.log({ details, data });
        }}
      />
    </div>
  );
}
